import React from "react";
import img1 from "../images/categoryImg/1.png";
import img2 from "../images/categoryImg/2.png";
import img3 from "../images/categoryImg/3.png";
import img4 from "../images/categoryImg/4.png";
import img5 from "../images/categoryImg/5.png";
import img6 from "../images/categoryImg/6.png";
import img7 from "../images/categoryImg/7.png";
import img8 from "../images/categoryImg/8.png";
import img9 from "../images/categoryImg/9.png";
import img10 from "../images/categoryImg/10.png";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import '../style/categoryweb_card.css'

export default function CategoryWeb_card() {
  return (
    <>
    <div className="container">
      <div class="row row-cols-1 row-cols-md-5 g-4 mt-3">
        <div class="col">
          <div class="card">
            <img src={img1} class="card-img-top" alt="..." />
            <div class="card-body">
              <h5 class="card-title">Card title</h5>
              <button className="explore_btn">Explore <ArrowForwardIosIcon/> </button>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card">
            <img src={img2} class="card-img-top" alt="..." />
            <div class="card-body">
              <h5 class="card-title">Card title</h5>
              <button className="explore_btn">Explore <ArrowForwardIosIcon/> </button>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card">
            <img src={img3} class="card-img-top" alt="..." />
            <div class="card-body">
              <h5 class="card-title">Card title</h5>
              <button className="explore_btn">Explore <ArrowForwardIosIcon/> </button>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card">
            <img src={img4} class="card-img-top" alt="..." />
            <div class="card-body">
              <h5 class="card-title">Card title</h5>
              <button className="explore_btn">Explore <ArrowForwardIosIcon/> </button>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card">
            <img src={img5} class="card-img-top" alt="..." />
            <div class="card-body">
              <h5 class="card-title">Card title</h5>
              <button className="explore_btn">Explore <ArrowForwardIosIcon/> </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-cols-1 row-cols-md-5 g-4 mt-3">
        <div class="col">
          <div class="card">
            <img src={img6} class="card-img-top" alt="..." />
            <div class="card-body">
              <h5 class="card-title">Card title</h5>
              <button className="explore_btn">Explore <ArrowForwardIosIcon/> </button>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card">
            <img src={img7} class="card-img-top" alt="..." />
            <div class="card-body">
              <h5 class="card-title">Card title</h5>
              <button className="explore_btn">Explore <ArrowForwardIosIcon/> </button>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card">
            <img src={img8} class="card-img-top" alt="..." />
            <div class="card-body">
              <h5 class="card-title">Card title</h5>
              <button className="explore_btn">Explore <ArrowForwardIosIcon/> </button>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card">
            <img src={img9} class="card-img-top" alt="..." />
            <div class="card-body">
              <h5 class="card-title">Card title</h5>
              <button className="explore_btn">Explore <ArrowForwardIosIcon/> </button>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card">
            <img src={img10} class="card-img-top" alt="..." />
            <div class="card-body">
              <h5 class="card-title">Card title</h5>
              <button className="explore_btn">Explore <ArrowForwardIosIcon/> </button>
            </div>
          </div>
        </div>
      </div>  
    </div>
    </>
  );
}

